import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal-900 text-white pt-24 pb-12 relative overflow-hidden" data-id="element-65">
      {/* Top Border Pattern */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold via-earth-terracotta to-gold" data-id="element-66" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-67">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-68">
          <div className="col-span-1 md:col-span-2" data-id="element-69">
            <h2 className="text-3xl font-sans font-black text-white mb-6" data-id="element-70">
              AFRICAN <span className="text-gold" data-id="element-71">FOUNDERS</span>
            </h2>
            <p className="font-serif text-archival-muted max-w-md text-lg leading-relaxed" data-id="element-72">
              An intellectual archive for the builders of tomorrow. Preserving
              the wisdom, failures, and triumphs of African entrepreneurship.
            </p>
          </div>

          <div data-id="element-73">
            <h4 className="font-mono text-gold text-sm uppercase tracking-widest mb-6 font-bold" data-id="element-74">
              Collection
            </h4>
            <ul className="space-y-4 font-sans text-archival-off" data-id="element-75">
              <li data-id="element-76">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-77">
                  Latest Episodes
                </a>
              </li>
              <li data-id="element-78">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-79">
                  The Archive
                </a>
              </li>
              <li data-id="element-80">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-81">
                  Founders Index
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-83">
                  Curated Series
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-84">
            <h4 className="font-mono text-gold text-sm uppercase tracking-widest mb-6 font-bold" data-id="element-85">
              Connect
            </h4>
            <ul className="space-y-4 font-sans text-archival-off" data-id="element-86">
              <li data-id="element-87">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-88">
                  Newsletter
                </a>
              </li>
              <li data-id="element-89">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-90">
                  Twitter / X
                </a>
              </li>
              <li data-id="element-91">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-92">
                  LinkedIn
                </a>
              </li>
              <li data-id="element-93">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-94">
                  Spotify
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-charcoal-700 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-archival-muted font-mono" data-id="element-95">
          <p data-id="element-96">© 2024 African Founders Pod. All rights reserved.</p>
          <div className="flex space-x-8 mt-4 md:mt-0" data-id="element-97">
            <a href="#" className="hover:text-white transition-colors" data-id="element-98">
              Privacy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-99">
              Terms
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-100">
              Sitemap
            </a>
          </div>
        </div>
      </div>

      {/* Background Watermark */}
      <div className="absolute bottom-0 right-0 opacity-5 pointer-events-none" data-id="element-101">
        <svg width="400" height="400" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-102">
          <circle cx="50" cy="50" r="40" stroke="white" strokeWidth="2" data-id="element-103" />
          <circle cx="50" cy="50" r="30" stroke="white" strokeWidth="2" data-id="element-104" />
          <path d="M50 10 V90 M10 50 H90" stroke="white" strokeWidth="2" data-id="element-105" />
        </svg>
      </div>
    </footer>;
}